<template>
    <div>
        <!-- Form -->
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="mb-1">{{$t('Treatment plan')}}</label>
                    <small
                        class="form-text text-muted"
                    >{{$t('Treatment plan print page description')}}</small>
                    <b-form-textarea
                        id="textareaPrintTemplate"
                        v-model="printTemplates.treatmentPlan"
                        :placeholder="$t('print plan note')"
                        :rows="3"
                        :max-rows="6"
                    ></b-form-textarea>
                </div>
            </div>
        </div>
        <!-- / .row -->
        <button-loading
            class="btn btn-lg btn-primary mb-3"
            :loading="isSavePending"
            @click="saveCompany()"
        >{{$t('Save')}}</button-loading>
    </div>
</template>

<script>
import Navigation from './Navigation.vue';
import ButtonLoading from '@/components/ButtonLoading'
import { companyMixins } from './mixins.js'

export default {
    name: 'company-generals',
    components: {
        Navigation,
        ButtonLoading
    },
    mixins: [companyMixins],
    watch: {
        printTemplates: {
            handler(newValue) {

                this.company.printTemplates = newValue;
            },
            deep: true
        }
    },
    data() {
        return {
            printTemplates: {
                treatmentPlan: ''
            }
        };
    },
    created() {
        this.getMyCompany("mine").then(data => {
            this.printTemplates = data.printTemplates || {};
        });
    },
    methods: {
    }


}
</script>
